/*
  Opens a linked document in a dialog on the page instead of a new tab.

  Why this file exists at all: Google Drive's /view URL answers with
  `x-frame-options: SAMEORIGIN`, so the address a merchant copies out of Drive cannot be put
  in an iframe - it renders an empty frame with no error anyone would notice in review. Drive
  has a separate /preview endpoint for embedding, and the section rewrites the address to it.
  This file only moves the already-correct URL into the frame.

  Deliberate choices:

  - The trigger stays a real <a href target="_blank">. With this file blocked, still loading,
    or the browser missing <dialog>, the click does what it always did and opens the document
    in a new tab. Nothing is lost, so there is no loading state to design.

  - The iframe gets its src on open and loses it on close. Set in the markup instead, every
    visitor who never touches the button would still fetch the document from Google, and a
    closed dialog would keep the embed alive behind it - the same class of problem as a muted
    video looping behind a modal.

  - Modified clicks (cmd, ctrl, shift, middle) are left alone. Someone asking for a new tab
    explicitly should get one.

  - `close` does not bubble, so its listener is registered in the capture phase. A listener
    added the ordinary way on document never fires for it.
*/
(function () {
  'use strict';

  if (window.oraluxDocModalBound) return;
  window.oraluxDocModalBound = true;

  var TRIGGER = '[data-oralux-doc-src]';
  var DIALOG = 'dialog[data-oralux-doc-dialog]';

  function frameOf(dialog) {
    return dialog.querySelector('[data-oralux-doc-frame]');
  }

  function release(dialog) {
    var frame = frameOf(dialog);
    /* Dropping the attribute, not setting it to about:blank: an empty src on an iframe is
       resolved against the current page in some browsers, which loads the shop inside itself. */
    if (frame) frame.removeAttribute('src');
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var trigger = event.target.closest(TRIGGER);
    if (!trigger) return;

    var source = trigger.getAttribute('data-oralux-doc-src');
    var dialogId = trigger.getAttribute('data-oralux-doc-target');
    var dialog = dialogId ? document.getElementById(dialogId) : null;

    /* Any missing piece means the plain link is still the better outcome. */
    if (!source || !dialog || typeof dialog.showModal !== 'function') return;

    event.preventDefault();

    var frame = frameOf(dialog);
    if (frame && frame.getAttribute('src') !== source) frame.setAttribute('src', source);
    dialog.showModal();
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target.closest(DIALOG);
    if (!dialog) return;
    /* A click on the backdrop lands on the dialog element itself, never on its content. */
    if (event.target === dialog || event.target.closest('[data-oralux-doc-close]')) dialog.close();
  });

  document.addEventListener(
    'close',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches(DIALOG)) release(target);
    },
    true
  );
})();
